import React, { forwardRef } from 'react';
import {
  Unstable_NumberInput as BaseNumberInput,
  NumberInputProps,
} from '@mui/base/Unstable_NumberInput';
import { useTheme, useMediaQuery } from "@mui/material";
import { StyledInputRoot, SmallStyledInput, LargeStyledInput, SmallStyledButton, LargeStyledButton} from './styles'
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

const NumberInput = forwardRef(function CustomNumberInput(
  props: NumberInputProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const StyledInput = isSmallScreen ? SmallStyledInput : LargeStyledInput;
  const StyledButton = isSmallScreen ? SmallStyledButton : LargeStyledButton;
  return (
    <BaseNumberInput
      slots={{
        root: StyledInputRoot,
        input: StyledInput,
        incrementButton: StyledButton,
        decrementButton: StyledButton,
      }}
      slotProps={{
        incrementButton: {
          children: <AddIcon sx={{ fontSize: '1rem', display: 'block', margin: 'auto' }} />,
          className: 'increment',
        },
        decrementButton: {
          children: <RemoveIcon sx={{ fontSize: '1rem', display: 'block', margin: 'auto' }} />,
        },
      }}
      {...props}
      ref={ref}
    />
  )
});

export default NumberInput;